import axios from 'axios'
import testOwners from 'components/HoldersModal/testOwners'
import * as config from '../config'
import { int2hex } from './encoding'

interface GetCollectionsType {
    address: string
}

const fetchWalletNFTs = () =>
    async function getWalletNFTs({ address }: GetCollectionsType) {
        try {
            const { data } = await axios.get(
                `${config.network.gatewayAddress}/address/${address}/esdt`
            )
            return {
                data: data,
                success: data !== undefined,
            }
        } catch (err) {
            return {
                success: false,
            }
        }
    }

const fetchCollectionNftCount = () =>
    async function getCollectionNftCount(collectionTicker: string) {
        try {
            const { data } = await axios.get(
                `${config.network.apiAddress}/nfts/count?collection=${collectionTicker}`
            )
            return {
                data: data,
                success: data !== undefined,
            }
        } catch (err) {
            return {
                success: false,
            }
        }
    }

const MAX_SIZE_WITH_OWNER = 100

const fetchCollectionNfts = () =>
    async function getCollectionNfts(collectionTicker: string, count: number) {
        try {
            let from = 0
            let result = []
            while (true) {
                const { data } = await axios.get(
                    `${config.network.apiAddress}/nfts?collection=${collectionTicker}&size=${MAX_SIZE_WITH_OWNER}&from=${from}&withOwner=true`
                )
                result.push(...data)
                from += data.length
                if (result.length === count) {
                    break
                }
            }
            return {
                data: result,
                success: true,
            }
        } catch (err) {
            return {
                success: false,
            }
        }
    }

const fetchAccountDetails = () =>
    async function getAccountDetails(address: string) {
        try {
            const { data } = await axios.get(
                `${config.network.apiAddress}/accounts/${address}`
            )
            return {
                data: data,
                success: data !== undefined,
            }
        } catch (err) {
            return {
                success: false,
            }
        }
    }

const fetchWalletBodies = () =>
    async function getWalletBodies(address: string) {
        try {
            const { data } = await axios.get(
                `${config.network.apiAddress}/accounts/${address}/nfts?size=100&search=LUNICORN-44e85e`
            )
            return {
                data: data,
                success: data !== undefined,
            }
        } catch (err) {
            return {
                success: false,
            }
        }
    }

const fetchWalletHeads = () =>
    async function getWalletHeads(address: string) {
        try {
            const { data } = await axios.get(
                `${config.network.apiAddress}/accounts/${address}/nfts?size=100&search=LUNIHEAD-485837`
            )
            return {
                data: data,
                success: data !== undefined,
            }
        } catch (err) {
            return {
                success: false,
            }
        }
    }

const fetchNftDetails = () =>
    async function getNftDetails(token: string, nonce: number) {
        try {
            const { data } = await axios.get(
                `${config.network.apiAddress}/nfts/${token}-${int2hex(nonce)}`
            )
            return {
                data: data,
                success: data !== undefined,
            }
        } catch (err) {
            return {
                success: false,
            }
        }
    }

const fetchNftOwner = () =>
    async function getNftOwner(identifier: string) {
        try {
            const { data } = await axios.get(
                `https://api.trust.market/nfts/${identifier}/owners`
            )
            return {
                data: data,
                success: data !== undefined,
            }
        } catch (err) {
            return {
                success: false,
            }
        }
    }

const fetchTopHolders = (collection: string) =>
    async function getTopHolders(token: string, nonce: number) {
        const notSuccessful = { success: false }
        try {
            const { data: count, success: countSuccess } =
                await fetchCollectionNftCount()(collection)
            if (!countSuccess) return notSuccessful
            const { data: nfts, success: nftSuccess } =
                await fetchCollectionNfts()(collection, count)
            if (!nftSuccess || !nfts) return notSuccessful

            const nftsWithOwner = nfts.map(({ identifier, owner }: any) => {
                return {
                    identifier,
                    owner,
                }
            })

            // const nftsWithOwner = testOwners

            const groupedByOwner = nftsWithOwner.reduce(
                (acc: any, { owner }: any) => {
                    if (!acc[owner]) {
                        acc[owner] = 0
                    }
                    acc[owner] += 1
                    return acc
                },
                {}
            )

            const groupedByOwnerAsArray = Object.keys(groupedByOwner).map(
                (owner: any) => ({ owner, count: groupedByOwner[owner] })
            )

            groupedByOwnerAsArray.sort((a, b) => b.count - a.count)

            return {
                data: groupedByOwnerAsArray.slice(0, 10),
                count,
                success: true,
            }
        } catch (err) {
            console.error(err)
            return notSuccessful
        }
    }

const fetchAccountNgmiBalance = () =>
    async function getAccountNgmiBalance(address: string) {
        try {
            const { data } = await axios.get(
                `${config.network.apiAddress}/accounts/${address}/tokens?identifiers=NGMI-dd4096`
            )
            return {
                data: data,
                success: data !== undefined,
            }
        } catch (err) {
            return {
                success: false,
            }
        }
    }

export const getWalletNFTs = fetchWalletNFTs()
export const getCollectionNFTCount = fetchCollectionNftCount()
export const getAccountDetails = fetchAccountDetails()
export const getWalletBodies = fetchWalletBodies()
export const getWalletHeads = fetchWalletHeads()
export const getNftDetails = fetchNftDetails()
export const getTopBodyHolders = fetchTopHolders('LUNICORN-44e85e')
export const getTopHeadHolders = fetchTopHolders('LUNIHEAD-485837')
export const getAccountNgmiBalance = fetchAccountNgmiBalance()
